import { clearFilter } from '../../../utils/filters/clear-filter';
import { selectFilterValues } from '../../../utils/filters/select-filter-values';
export const updateFilter = (id, type, filtersToDisplay, selectedValues) => {
    clearFilter({ id, type, keys: filtersToDisplay });
    selectFilterValues({ id, type, values: selectedValues });
};
